export const servicesData = [
  {
    id: '1',
    category: 'Technology',
    title: 'Web Development',
    description: 'Custom website and web application development with modern technologies. We build responsive, fast, and SEO-friendly websites tailored to your business needs.',
    fullDescription: 'Our web development service provides end-to-end solutions for businesses looking to establish or enhance their online presence. We use cutting-edge technologies including React, TypeScript, and modern frameworks to create fast, responsive, and user-friendly websites. Each project includes comprehensive planning, custom design, development, testing, and deployment with ongoing support.',
    price: 999,
    commission: 299,
    features: ['Responsive Design', 'SEO Optimization', 'Fast Loading', 'Custom Features'],
    detailedFeatures: [
      { title: 'Custom Design', desc: 'Unique designs tailored to your brand identity' },
      { title: 'Mobile Responsive', desc: 'Perfect display on all devices and screen sizes' },
      { title: 'SEO Optimized', desc: 'Built-in SEO best practices for better rankings' },
      { title: 'Fast Performance', desc: 'Optimized for lightning-fast loading speeds' },
      { title: 'Security', desc: 'SSL encryption and security best practices' },
      { title: 'Analytics Integration', desc: 'Track visitor behavior and conversions' },
      { title: 'Content Management', desc: 'Easy-to-use CMS for content updates' },
      { title: 'Support & Maintenance', desc: '30 days of free support after launch' },
    ],
    deliveryTime: '14-21 days',
    revisions: '3 revisions included',
    image: 'https://public.readdy.ai/ai/img_res/77f2305cd1d9da6c4f9f4fcd969c1d94.jpg',
    automated: true,
  },
  {
    id: '2',
    category: 'Marketing',
    title: 'Digital Marketing',
    description: 'Comprehensive digital marketing services including SEO, social media management, content marketing, and paid advertising to grow your online presence.',
    fullDescription: 'Transform your online presence with our comprehensive digital marketing services. We create data-driven strategies that combine SEO, social media marketing, content creation, and paid advertising to maximize your ROI. Our team of experts will help you reach your target audience, increase brand awareness, and drive conversions through proven marketing techniques.',
    price: 799,
    commission: 239,
    features: ['SEO Strategy', 'Social Media', 'Content Creation', 'Analytics'],
    detailedFeatures: [
      { title: 'SEO Strategy', desc: 'Comprehensive keyword research and optimization' },
      { title: 'Social Media Management', desc: 'Daily posting and community engagement' },
      { title: 'Content Marketing', desc: 'Blog posts, articles, and engaging content' },
      { title: 'Paid Advertising', desc: 'Google Ads and social media ad campaigns' },
      { title: 'Email Marketing', desc: 'Targeted email campaigns and newsletters' },
      { title: 'Analytics & Reporting', desc: 'Monthly performance reports and insights' },
      { title: 'Competitor Analysis', desc: 'Stay ahead of your competition' },
      { title: 'Brand Strategy', desc: 'Develop strong brand positioning' },
    ],
    deliveryTime: 'Ongoing monthly service',
    revisions: 'Unlimited adjustments',
    image: 'https://readdy.ai/api/search-image?query=digital%20marketing%20dashboard%20displaying%20analytics%20graphs%20social%20media%20metrics%20and%20campaign%20performance%20on%20sleek%20computer%20screens%20in%20modern%20bright%20office%20with%20clean%20white%20background&width=1200&height=600&seq=servdet2&orientation=landscape',
    automated: true,
  },
  {
    id: '3',
    category: 'Design',
    title: 'Brand Identity Design',
    description: 'Complete brand identity packages including logo design, color schemes, typography, and brand guidelines to establish a strong visual presence.',
    fullDescription: 'Create a memorable brand identity that sets you apart from competitors. Our comprehensive branding service includes logo design, color palette selection, typography, brand guidelines, and all marketing materials. We work closely with you to understand your vision and create a cohesive brand identity that resonates with your target audience.',
    price: 1299,
    commission: 389,
    features: ['Logo Design', 'Brand Guidelines', 'Marketing Materials', 'Style Guide'],
    detailedFeatures: [
      { title: 'Logo Design', desc: '3 unique logo concepts with unlimited revisions' },
      { title: 'Color Palette', desc: 'Custom color scheme for your brand' },
      { title: 'Typography', desc: 'Professional font selection and pairing' },
      { title: 'Brand Guidelines', desc: 'Complete brand style guide document' },
      { title: 'Business Cards', desc: 'Professional business card design' },
      { title: 'Letterhead', desc: 'Branded letterhead and stationery' },
      { title: 'Social Media Kit', desc: 'Profile images and cover photos' },
      { title: 'Source Files', desc: 'All design files in multiple formats' },
    ],
    deliveryTime: '10-14 days',
    revisions: 'Unlimited revisions',
    image: 'https://readdy.ai/api/search-image?query=brand%20identity%20design%20showcase%20with%20elegant%20logo%20variations%20business%20cards%20and%20branding%20materials%20beautifully%20arranged%20on%20clean%20white%20surface%20with%20professional%20studio%20lighting&width=1200&height=600&seq=servdet3&orientation=landscape',
    automated: true,
  },
  {
    id: '4',
    category: 'E-commerce',
    title: 'E-commerce Solutions',
    description: 'Full-service e-commerce setup including store design, payment integration, inventory management, and ongoing support for your online business.',
    fullDescription: 'Launch your online store with our complete e-commerce solution. We handle everything from store design and product setup to payment gateway integration and inventory management. Our e-commerce platforms are built for conversion, with user-friendly interfaces, secure checkout processes, and powerful admin tools to manage your business efficiently.',
    price: 1499,
    commission: 449,
    features: ['Store Setup', 'Payment Integration', 'Product Management', 'Security'],
    detailedFeatures: [
      { title: 'Store Design', desc: 'Custom e-commerce website design' },
      { title: 'Product Setup', desc: 'Upload and organize your products' },
      { title: 'Payment Gateway', desc: 'Secure payment processing integration' },
      { title: 'Shopping Cart', desc: 'Advanced cart and checkout system' },
      { title: 'Inventory Management', desc: 'Track stock levels automatically' },
      { title: 'Order Management', desc: 'Efficient order processing system' },
      { title: 'Customer Accounts', desc: 'User registration and profiles' },
      { title: 'SSL Security', desc: 'Secure transactions and data protection' },
    ],
    deliveryTime: '21-30 days',
    revisions: '2 revisions included',
    image: 'https://readdy.ai/api/search-image?query=e-commerce%20platform%20interface%20showing%20beautiful%20product%20gallery%20shopping%20cart%20and%20secure%20checkout%20pages%20on%20modern%20devices%20in%20bright%20minimalist%20workspace%20with%20white%20background&width=1200&height=600&seq=servdet4&orientation=landscape',
    automated: true,
  },
  {
    id: '5',
    category: 'Consulting',
    title: 'Business Consulting',
    description: 'Strategic business consulting to help you grow your company, optimize operations, and achieve your business goals with expert guidance.',
    fullDescription: 'Accelerate your business growth with expert consulting services. Our experienced consultants provide strategic guidance on business planning, operations optimization, market analysis, and growth strategies. We work with you to identify opportunities, overcome challenges, and implement effective solutions that drive measurable results.',
    price: 599,
    commission: 179,
    features: ['Strategy Planning', 'Market Analysis', 'Growth Consulting', 'Performance Review'],
    detailedFeatures: [
      { title: 'Business Strategy', desc: 'Comprehensive strategic planning sessions' },
      { title: 'Market Research', desc: 'In-depth market and competitor analysis' },
      { title: 'Financial Planning', desc: 'Budget optimization and forecasting' },
      { title: 'Operations Review', desc: 'Process improvement recommendations' },
      { title: 'Growth Strategy', desc: 'Scalable growth roadmap development' },
      { title: 'Performance Metrics', desc: 'KPI tracking and optimization' },
      { title: 'Action Plan', desc: 'Detailed implementation roadmap' },
      { title: 'Follow-up Support', desc: '60 days of email consultation' },
    ],
    deliveryTime: '7-10 days',
    revisions: 'Ongoing consultation',
    image: 'https://readdy.ai/api/search-image?query=business%20consulting%20meeting%20with%20professional%20charts%20graphs%20and%20strategic%20planning%20documents%20on%20clean%20white%20desk%20with%20laptop%20and%20coffee%20in%20bright%20modern%20office&width=1200&height=600&seq=servdet5&orientation=landscape',
    automated: true,
  },
  {
    id: '6',
    category: 'Content',
    title: 'Content Creation',
    description: 'Professional content writing and creation services for blogs, websites, social media, and marketing materials that engage your audience.',
    fullDescription: 'Engage your audience with high-quality content that drives results. Our content creation service includes blog writing, website copy, social media content, and marketing materials. We create SEO-optimized, compelling content that resonates with your target audience and supports your business goals.',
    price: 399,
    commission: 119,
    features: ['Blog Writing', 'Copywriting', 'Social Content', 'SEO Content'],
    detailedFeatures: [
      { title: 'Blog Articles', desc: '4-8 professional blog posts per month' },
      { title: 'Website Copy', desc: 'Compelling website content and pages' },
      { title: 'Social Media Posts', desc: 'Daily social media content creation' },
      { title: 'SEO Optimization', desc: 'Keyword research and optimization' },
      { title: 'Email Newsletters', desc: 'Engaging email content and campaigns' },
      { title: 'Product Descriptions', desc: 'Persuasive product copy' },
      { title: 'Content Strategy', desc: 'Monthly content calendar and planning' },
      { title: 'Editing & Proofreading', desc: 'Professional editing included' },
    ],
    deliveryTime: 'Ongoing monthly service',
    revisions: '2 revisions per piece',
    image: 'https://readdy.ai/api/search-image?query=content%20creation%20workspace%20with%20elegant%20notebook%20laptop%20and%20creative%20writing%20materials%20on%20clean%20white%20desk%20in%20bright%20minimalist%20environment%20with%20natural%20lighting&width=1200&height=600&seq=servdet6&orientation=landscape',
    automated: true,
  },
  {
    id: '7',
    category: 'Health & Fitness',
    title: 'Personal Training Program',
    description: 'Customized fitness training programs with one-on-one coaching, nutrition guidance, and progress tracking to help you achieve your health goals.',
    fullDescription: 'Transform your body and health with our personalized training programs. Our certified personal trainers create custom workout plans tailored to your fitness level, goals, and lifestyle. Each program includes detailed exercise routines, nutrition planning, progress tracking, and ongoing support to ensure you achieve lasting results.',
    price: 899,
    commission: 269,
    features: ['Custom Workout Plans', 'Nutrition Guidance', 'Progress Tracking', 'Video Coaching'],
    detailedFeatures: [
      { title: 'Fitness Assessment', desc: 'Complete body composition and fitness evaluation' },
      { title: 'Custom Workout Plan', desc: 'Personalized exercise routines for your goals' },
      { title: 'Nutrition Planning', desc: 'Meal plans and dietary recommendations' },
      { title: 'Video Demonstrations', desc: 'Proper form and technique guidance' },
      { title: 'Progress Tracking', desc: 'Weekly measurements and photo documentation' },
      { title: 'Live Coaching Sessions', desc: '4 virtual training sessions per month' },
      { title: 'Mobile App Access', desc: 'Track workouts and meals on the go' },
      { title: '24/7 Support', desc: 'Message your trainer anytime' },
    ],
    deliveryTime: '3-month program',
    revisions: 'Adjustments as needed',
    image: 'https://readdy.ai/api/search-image?query=personal%20fitness%20training%20session%20with%20professional%20trainer%20demonstrating%20exercises%20in%20modern%20bright%20gym%20with%20clean%20white%20walls%20and%20natural%20lighting%20showing%20workout%20equipment%20and%20motivational%20atmosphere&width=1200&height=600&seq=servdet7&orientation=landscape',
    automated: true,
  },
  {
    id: '8',
    category: 'Health & Fitness',
    title: 'Nutrition Coaching',
    description: 'Expert nutrition coaching with personalized meal plans, dietary guidance, and ongoing support to optimize your health and wellness.',
    fullDescription: 'Achieve optimal health through proper nutrition with our expert coaching services. Our certified nutritionists create personalized meal plans based on your goals, dietary preferences, and lifestyle. Get comprehensive nutritional guidance, recipe ideas, supplement recommendations, and continuous support to develop sustainable healthy eating habits.',
    price: 699,
    commission: 209,
    features: ['Meal Planning', 'Dietary Analysis', 'Recipe Library', 'Weekly Check-ins'],
    detailedFeatures: [
      { title: 'Nutritional Assessment', desc: 'Complete dietary and health evaluation' },
      { title: 'Custom Meal Plans', desc: 'Personalized weekly meal planning' },
      { title: 'Macro Calculations', desc: 'Precise macronutrient targets for your goals' },
      { title: 'Recipe Database', desc: 'Access to 500+ healthy recipes' },
      { title: 'Grocery Lists', desc: 'Weekly shopping lists generated automatically' },
      { title: 'Supplement Guidance', desc: 'Evidence-based supplement recommendations' },
      { title: 'Weekly Check-ins', desc: 'Progress reviews and plan adjustments' },
      { title: 'Educational Resources', desc: 'Nutrition guides and learning materials' },
    ],
    deliveryTime: '3-month program',
    revisions: 'Weekly adjustments',
    image: 'https://readdy.ai/api/search-image?query=healthy%20nutrition%20coaching%20setup%20with%20fresh%20colorful%20vegetables%20fruits%20meal%20prep%20containers%20and%20nutrition%20planning%20documents%20on%20clean%20white%20kitchen%20counter%20with%20bright%20natural%20lighting&width=1200&height=600&seq=servdet8&orientation=landscape',
    automated: true,
  },
  {
    id: '9',
    category: 'Health & Fitness',
    title: 'Yoga & Meditation Classes',
    description: 'Online yoga and meditation classes for all levels, including guided sessions, breathing techniques, and mindfulness practices for stress relief.',
    fullDescription: 'Find balance and inner peace with our comprehensive yoga and meditation programs. Our experienced instructors offer live and recorded classes suitable for all levels, from beginners to advanced practitioners. Learn proper techniques, improve flexibility, reduce stress, and enhance your overall well-being through regular practice.',
    price: 499,
    commission: 149,
    features: ['Live Classes', 'On-Demand Videos', 'Meditation Guides', 'Breathing Techniques'],
    detailedFeatures: [
      { title: 'Live Yoga Classes', desc: '12 live classes per month via video' },
      { title: 'Video Library', desc: 'Access to 200+ recorded sessions' },
      { title: 'Meditation Programs', desc: 'Guided meditation for stress relief' },
      { title: 'Breathing Exercises', desc: 'Pranayama techniques for wellness' },
      { title: 'Flexibility Training', desc: 'Improve range of motion and mobility' },
      { title: 'Stress Management', desc: 'Mindfulness practices for daily life' },
      { title: 'Progress Tracking', desc: 'Track your practice and improvements' },
      { title: 'Community Access', desc: 'Join our supportive yoga community' },
    ],
    deliveryTime: 'Monthly subscription',
    revisions: 'Ongoing access',
    image: 'https://readdy.ai/api/search-image?query=peaceful%20yoga%20meditation%20class%20with%20instructor%20in%20serene%20bright%20studio%20with%20white%20walls%20natural%20light%20yoga%20mats%20and%20calming%20minimalist%20atmosphere%20showing%20wellness%20and%20mindfulness%20practice&width=1200&height=600&seq=servdet9&orientation=landscape',
    automated: true,
  },
  {
    id: '10',
    category: 'Health & Fitness',
    title: 'Weight Loss Program',
    description: 'Comprehensive weight loss program combining fitness training, nutrition coaching, and behavioral support to help you lose weight sustainably.',
    fullDescription: 'Achieve your weight loss goals with our proven comprehensive program. Combining personalized fitness plans, nutrition coaching, and behavioral support, we help you lose weight safely and sustainably. Our holistic approach addresses all aspects of weight management, ensuring long-term success and improved overall health.',
    price: 1199,
    commission: 359,
    features: ['Fitness Training', 'Meal Planning', 'Behavioral Coaching', 'Accountability'],
    detailedFeatures: [
      { title: 'Initial Assessment', desc: 'Complete health and fitness evaluation' },
      { title: 'Custom Workout Plan', desc: 'Fat-burning exercise routines' },
      { title: 'Nutrition Program', desc: 'Calorie-controlled meal plans' },
      { title: 'Behavioral Coaching', desc: 'Address emotional eating and habits' },
      { title: 'Weekly Weigh-ins', desc: 'Track progress and adjust strategies' },
      { title: 'Accountability Partner', desc: 'Daily check-ins and motivation' },
      { title: 'Group Support', desc: 'Join our weight loss community' },
      { title: 'Maintenance Plan', desc: 'Keep the weight off long-term' },
    ],
    deliveryTime: '6-month program',
    revisions: 'Continuous adjustments',
    image: 'https://readdy.ai/api/search-image?query=weight%20loss%20transformation%20program%20showing%20healthy%20meal%20prep%20fitness%20equipment%20measuring%20tape%20and%20progress%20tracking%20tools%20in%20bright%20motivational%20setting%20with%20clean%20white%20background&width=1200&height=600&seq=servdet10&orientation=landscape',
    automated: true,
  },
  {
    id: '11',
    category: 'Health & Fitness',
    title: 'Sports Performance Training',
    description: 'Elite sports performance training for athletes looking to improve strength, speed, agility, and overall athletic performance.',
    fullDescription: 'Take your athletic performance to the next level with our specialized sports training programs. Designed for competitive athletes, our programs focus on sport-specific skills, strength and conditioning, injury prevention, and mental performance. Work with experienced coaches who understand the demands of competitive sports.',
    price: 1499,
    commission: 449,
    features: ['Sport-Specific Training', 'Strength & Conditioning', 'Injury Prevention', 'Mental Coaching'],
    detailedFeatures: [
      { title: 'Performance Assessment', desc: 'Comprehensive athletic testing and evaluation' },
      { title: 'Sport-Specific Drills', desc: 'Customized training for your sport' },
      { title: 'Strength Training', desc: 'Build power and explosive strength' },
      { title: 'Speed & Agility', desc: 'Improve quickness and reaction time' },
      { title: 'Conditioning', desc: 'Enhance endurance and stamina' },
      { title: 'Injury Prevention', desc: 'Mobility work and prehab exercises' },
      { title: 'Mental Training', desc: 'Sports psychology and visualization' },
      { title: 'Recovery Protocols', desc: 'Optimize rest and regeneration' },
    ],
    deliveryTime: '6-month program',
    revisions: 'Monthly assessments',
    image: 'https://readdy.ai/api/search-image?query=elite%20sports%20performance%20training%20with%20athlete%20doing%20explosive%20exercises%20in%20professional%20training%20facility%20with%20modern%20equipment%20bright%20lighting%20and%20motivational%20atmosphere&width=1200&height=600&seq=servdet11&orientation=landscape',
    automated: true,
  },
  {
    id: '12',
    category: 'Health & Fitness',
    title: 'Corporate Wellness Program',
    description: 'Comprehensive workplace wellness programs to improve employee health, reduce stress, and boost productivity in your organization.',
    fullDescription: 'Invest in your team\'s health and well-being with our corporate wellness programs. We provide on-site or virtual fitness classes, health screenings, stress management workshops, and wellness challenges designed to create a healthier, more productive workplace. Improve employee morale, reduce healthcare costs, and boost overall company performance.',
    price: 2499,
    commission: 749,
    features: ['Group Fitness Classes', 'Health Screenings', 'Wellness Workshops', 'Team Challenges'],
    detailedFeatures: [
      { title: 'Fitness Classes', desc: 'Weekly group exercise sessions' },
      { title: 'Health Assessments', desc: 'Biometric screenings for employees' },
      { title: 'Nutrition Seminars', desc: 'Educational workshops on healthy eating' },
      { title: 'Stress Management', desc: 'Mindfulness and relaxation techniques' },
      { title: 'Wellness Challenges', desc: 'Fun team competitions and incentives' },
      { title: 'Ergonomic Evaluations', desc: 'Workspace optimization for health' },
      { title: 'Mental Health Support', desc: 'Resources and counseling services' },
      { title: 'Progress Reporting', desc: 'Track company-wide wellness metrics' },
    ],
    deliveryTime: '12-month program',
    revisions: 'Quarterly reviews',
    image: 'https://readdy.ai/api/search-image?query=corporate%20wellness%20program%20with%20diverse%20employees%20participating%20in%20group%20fitness%20class%20in%20modern%20bright%20office%20space%20with%20professional%20trainers%20and%20healthy%20workplace%20atmosphere&width=1200&height=600&seq=servdet12&orientation=landscape',
    automated: true,
  },
  {
    id: '13',
    category: 'Technology',
    title: 'Mobile App Development',
    description: 'Custom mobile application development for iOS and Android platforms with modern design, seamless functionality, and user-friendly interfaces.',
    fullDescription: 'Bring your app idea to life with our professional mobile development services. We create native and cross-platform applications that deliver exceptional user experiences. From concept to launch, we handle design, development, testing, and deployment, ensuring your app meets the highest standards of quality and performance.',
    price: 2499,
    commission: 749,
    features: ['iOS & Android', 'Custom Design', 'API Integration', 'App Store Launch'],
    detailedFeatures: [
      { title: 'Platform Development', desc: 'Native iOS and Android apps' },
      { title: 'UI/UX Design', desc: 'Beautiful, intuitive interfaces' },
      { title: 'Backend Integration', desc: 'Connect to databases and APIs' },
      { title: 'Push Notifications', desc: 'Engage users with timely alerts' },
      { title: 'In-App Purchases', desc: 'Monetization features built-in' },
      { title: 'Analytics Integration', desc: 'Track user behavior and metrics' },
      { title: 'App Store Submission', desc: 'Handle all submission requirements' },
      { title: 'Post-Launch Support', desc: '60 days of maintenance included' },
    ],
    deliveryTime: '30-45 days',
    revisions: '3 revisions included',
    image: 'https://readdy.ai/api/search-image?query=mobile%20app%20development%20workspace%20showing%20smartphone%20screens%20with%20modern%20app%20interfaces%20code%20on%20monitors%20and%20design%20mockups%20in%20bright%20professional%20office%20with%20clean%20aesthetic&width=1200&height=600&seq=servdet13&orientation=landscape',
    automated: true,
  },
  {
    id: '14',
    category: 'Marketing',
    title: 'Social Media Management',
    description: 'Full-service social media management including content creation, posting, engagement, and analytics across all major platforms.',
    fullDescription: 'Grow your social media presence with our comprehensive management services. We handle everything from content creation and scheduling to community engagement and performance analytics. Our team creates compelling posts, responds to comments, runs campaigns, and provides detailed reports to maximize your social media ROI.',
    price: 899,
    commission: 269,
    features: ['Content Creation', 'Daily Posting', 'Community Management', 'Analytics Reports'],
    detailedFeatures: [
      { title: 'Content Strategy', desc: 'Monthly content calendar and planning' },
      { title: 'Post Creation', desc: '30+ custom posts per month' },
      { title: 'Platform Management', desc: 'Facebook, Instagram, Twitter, LinkedIn' },
      { title: 'Community Engagement', desc: 'Respond to comments and messages' },
      { title: 'Hashtag Research', desc: 'Optimize reach with trending hashtags' },
      { title: 'Influencer Outreach', desc: 'Connect with relevant influencers' },
      { title: 'Ad Campaign Management', desc: 'Run and optimize paid campaigns' },
      { title: 'Monthly Reports', desc: 'Detailed analytics and insights' },
    ],
    deliveryTime: 'Monthly subscription',
    revisions: 'Unlimited adjustments',
    image: 'https://readdy.ai/api/search-image?query=social%20media%20management%20dashboard%20showing%20multiple%20platform%20feeds%20engagement%20metrics%20and%20content%20calendar%20on%20modern%20computer%20screens%20in%20bright%20creative%20workspace&width=1200&height=600&seq=servdet14&orientation=landscape',
    automated: true,
  },
  {
    id: '15',
    category: 'Design',
    title: 'Video Production',
    description: 'Professional video production services including scripting, filming, editing, and post-production for marketing, training, and promotional content.',
    fullDescription: 'Create compelling video content that captures attention and drives results. Our video production team handles every aspect of the process, from concept development and scripting to filming, editing, and final delivery. We produce high-quality videos for marketing campaigns, product demos, training materials, and social media content.',
    price: 1799,
    commission: 539,
    features: ['Scriptwriting', 'Professional Filming', 'Video Editing', 'Motion Graphics'],
    detailedFeatures: [
      { title: 'Concept Development', desc: 'Creative brainstorming and planning' },
      { title: 'Script Writing', desc: 'Professional copywriting for videos' },
      { title: 'Professional Filming', desc: '4K video production with pro equipment' },
      { title: 'Video Editing', desc: 'Expert editing and color grading' },
      { title: 'Motion Graphics', desc: 'Animated text and visual effects' },
      { title: 'Sound Design', desc: 'Music, voiceover, and audio mixing' },
      { title: 'Multiple Formats', desc: 'Optimized for all platforms' },
      { title: 'Revisions', desc: 'Up to 3 rounds of changes' },
    ],
    deliveryTime: '14-21 days',
    revisions: '3 revisions included',
    image: 'https://readdy.ai/api/search-image?query=professional%20video%20production%20studio%20with%20cameras%20lighting%20equipment%20and%20editing%20workstation%20showing%20creative%20filmmaking%20process%20in%20modern%20bright%20space&width=1200&height=600&seq=servdet15&orientation=landscape',
    automated: true,
  },
];

export const serviceCategories = [
  { id: 'all', name: 'All Services', icon: 'ri-apps-line' },
  { id: 'Technology', name: 'Technology', icon: 'ri-code-line' },
  { id: 'Marketing', name: 'Marketing', icon: 'ri-megaphone-line' },
  { id: 'Design', name: 'Design', icon: 'ri-palette-line' },
  { id: 'E-commerce', name: 'E-commerce', icon: 'ri-shopping-cart-line' },
  { id: 'Consulting', name: 'Consulting', icon: 'ri-briefcase-line' },
  { id: 'Content', name: 'Content', icon: 'ri-article-line' },
  { id: 'Health & Fitness', name: 'Health & Fitness', icon: 'ri-heart-pulse-line' },
];
